import React from 'react';
import { ListItem, ListItemText, Button, Avatar, Icon, Typography } from '@material-ui/core';
import { get, uniqBy } from 'global/lib/lodash';
import useStyles from './TaskList.styles';
import { useScreen } from 'global/styles';
import moment from 'moment';

export default (props) => {
  const { isMobile } = useScreen();
  const item = props.itemOverride || props.item;

  const classes = useStyles({ isMobile });

  const clickDownload = (it) => {
    const url = get(it, 'full7DayUrl', get(it, 'fullUrl'));
    if (url) {
      window.open(url, '_blank');
    }
  };

  const content = {
    label: moment(get(item, 'createdAt')).format('dddd, MMMM DD, YYYY'),
    from: get(item, 'from.name', ''),
    to: get(item, 'users', []).map(u => u.name).join(', ') || 'N/A',
    media: uniqBy(get(item, 'media', []), 'customProperties.tradeType'),
  };
  content.icon = <Icon>description</Icon>;
  const dayDiff = Math.abs(moment(content.agingDate).diff(moment(), 'days'));
  content.timerClassName = dayDiff > 21 ? classes.redIcon : dayDiff > 7 ? classes.orangeIcon : classes.greyIcon;

  const renderMediaItem = (it, i) => {
    return (
      <div key={i}>
        <Button style={{ justifyContent: 'flex-start' }} size="small" onClick={() => clickDownload(it)} startIcon={<Icon>get_app</Icon>}>{get(it, 'customProperties.tradeType', 'ALL')}</Button>
      </div>
    )
  }

  return (
    <ListItem component={'div'} key={item.id}>
      <Avatar className={classes.avatar}>{content.icon}</Avatar>
      <ListItemText
        classes={{ primary: classes.listItemHeader }}
        primary={content.label}
        secondaryTypographyProps={{ component: 'div' }}
        secondary={
          <>
            <Typography classes={{ root: classes.datesText }}>{`From: ${content.from}`}</Typography>
            <Typography classes={{ root: classes.datesText }}>{`To: ${content.to}`}</Typography>
            {content.media.map(renderMediaItem)}
          </>
        }
      />
    </ListItem>
  );
};
